<template>
  <v-navigation-drawer
    :model-value="show"
    color="primary"
    temporary
    location="right"
    width="600"
    @update:model-value="change"
  >
    <div class="pa-8">
      <div class="d-flex justify-space-between align-center">
        <h1 class="text-white mt-6">Media browser</h1>
        <v-btn variant="text" @click="show = false" icon
          ><v-icon color="white">mdi-close</v-icon>
        </v-btn>
      </div>

      <p class="mb-4 text-white" style="font-size: 12px">
        You can browse through free stock photos and videos from Pexels, or
        upload your own media.
      </p>

      <v-tabs
        class="ml-2"
        height="35"
        background-color="transparent"
        hide-slider
        selected-class="active-tab"
        v-model="tab"
      >
        <v-tab style="border-radius: 6px 6px 0 0" class="tab mr-1"
          >Uploads</v-tab
        >
        <!-- <v-tab style="border-radius: 6px 6px 0 0" class="tab mr-1">AI</v-tab> -->
        <!-- <v-tab style="border-radius: 6px 6px 0 0" class="tab mr-1"
          >Stock photos</v-tab
        > -->

        <!-- <v-tab
          style="border-radius: 6px 6px 0 0"
          class="tab"
          v-if="!type || !type.includes('template.background')"
        >
          Templates
        </v-tab> -->
      </v-tabs>
      <v-card flat class="pt-4" color="white" v-if="userProfile">
        <div v-if="tab === 2">
          <div
            style="display: grid; grid-template-columns: 1fr 1fr; gap: 10px"
            class="px-4 pb-4"
          >
            <v-text-field
              label="Search"
              style="border-radius: 6px"
              variant="solo"
              v-model="search"
              flat
              density="compact"
              hide-details=""
              bg-color="smoke"
              @keypress="enter"
            ></v-text-field>
            <v-btn
              block
              elevation="0"
              height="38"
              color="accent"
              class="primary--text"
              :loading="search_loading"
              @click="searchMedia"
            >
              Search stock
            </v-btn>
          </div>

          <!-- <div v-if="items.length > 0">
            <p
              class="text-center"
              style="font-size: 12px; font-weight: 00; margin-bottom: 5px"
            >
              Preview size:
            </p>
            <div class="pb-4 px-4 d-flex align-center justify-center">
              <v-btn-toggle
                v-model="userProfile.preferences.preview_size"
                density="compact"
              >
                <v-btn value="small" @click="setPreviewSize('small')">
                  Small
                </v-btn>
                <v-btn value="medium" @click="setPreviewSize('medium')">
                  Medium
                </v-btn>
                <v-btn value="large" @click="setPreviewSize('large')">
                  Large
                </v-btn>
              </v-btn-toggle>
            </div>
          </div> -->
          <div
            class="stockphotos px-4"
            :class="userProfile.preferences.preview_size"
          >
            <div
              v-for="(i, index) in items"
              :key="index"
              @click="selectStockMedia({ ...i, type: 'stock' })"
            >
              <img :src="i.src.large" />
            </div>
          </div>
          <div
            class="d-flex justify-center"
            v-if="!search_loading && items.length > 0"
          >
            <v-btn @click="nextPage" outlined elevation="0" class="px-6 my-4"
              >Load more</v-btn
            >
          </div>
        </div>
        <div v-if="tab === 0">
          <div class="d-flex justify-space-between align-center mb-6 px-4">
            <v-btn
              height="38"
              color="buttonGreen"
              class="mr-4"
              @click="useSelectedMedia"
              variant="flat"
              v-if="selected.length > 0"
              >Add media</v-btn
            >
            <v-btn
              height="38"
              elevation="0"
              color="accent"
              class="primary--text"
              @click="trigger"
              style="font-size: 10pt"
              >Upload media</v-btn
            >
            <input
              v-if="!userProfile.trialEnded"
              ref="headerRef"
              type="file"
              multiple
              @change="onFileChange"
              @click="resetValue"
              accept="image/jpeg, image/png, image/jpg, video/mp4"
            />
            <v-text-field
              class="px-4"
              variant="solo"
              flat
              label="Filter media"
              hide-details=""
              density="compact"
              bg-color="smoke"
              style="border-radius: 6px"
              prepend-inner-icon="mdi-magnify"
              v-model="search_media"
            ></v-text-field>
          </div>
          <div
            v-if="search_loading"
            style="width: 100%"
            class="d-flex justify-center mt-6"
          >
            <v-progress-circular
              indeterminate
              color="accent"
              width="2"
            ></v-progress-circular>
          </div>

          <v-data-table
            :headers="headers"
            :items="media"
            :items-per-page="5"
            hide-default-header
            @click:row="selectMedia"
            style="cursor: pointer"
            item-value="uid"
            :search="search_media"
            :loading="media_loading"
            :show-select="selected.length > 0"
            v-model="selected"
            @update:model-value="onSelectionChange"
          >
            <template v-slot:[`item.url`]="{ item }">
              <div style="width: 100px">
                <v-img
                  :src="item.thumbnail ? item.thumbnail : item.src"
                  height="100"
                  width="100"
                  cover
                  class="d-flex align-center justify-center"
                >
                </v-img>
              </div>
            </template>

            <template v-slot:[`item.title`]="{ item }">
              <div>
                <p class="mb-1">{{ item.title }}</p>
                <p
                  class="mb-0"
                  style="font-size: 10px; font-weight: 600; opacity: 0.4"
                >
                  {{ Number.parseFloat(item.size / 1024).toFixed(1) }}MB &#183;
                  {{ item.extension.toUpperCase() }} &#183;
                  {{ item.created_by_email.toUpperCase() }} &#183;
                  {{ formatDate(item.created_at) }}
                </p>
              </div>
            </template>

            <template v-slot:[`item.actions`]="{ item }">
              <v-menu transition="slide-y-transition" bottom>
                <template v-slot:activator="{ props }">
                  <v-btn
                    variant="text"
                    icon="mdi-dots-vertical"
                    size="small"
                    v-bind="props"
                  >
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item
                    link
                    class="px-4"
                    @click="$store.dispatch('deleteMedia', item.uid)"
                  >
                    <v-icon size="small" class="mr-3">mdi-delete</v-icon> Delete
                  </v-list-item>
                </v-list>
              </v-menu>
            </template>
          </v-data-table>
        </div>
        <div class="mb-6 px-4" v-if="tab === 1">
          <v-textarea
            v-if="status === 'prompt' || status === 'reprompt'"
            v-model="imagePrompt"
            hide-details=""
            class="mb-3"
            placeholder="Generate an image of gray tabby cat hugging an otter with an orange scarf"
            :loading="generatingImages"
            @keyup.enter="generateImage"
          >
            <template v-slot:append-inner>
              <v-btn
                color="primary"
                size="small"
                height="30"
                variant="flat"
                :disable="imagePrompt.length < 3"
                @click="generateImage"
              >
                <span class="text-white" :loading="generatingImages"
                  >Generate</span
                >
              </v-btn>
            </template>
          </v-textarea>
          <!-- <v-select
            item-title="name"
            :items="prompts"
            v-model="prompt"
            return-object=""
            v-if="status === 'prompt'"
          ></v-select> -->
          <p
            v-if="post_text && status != 'generating'"
            style="font-size: 9pt; cursor: pointer"
            @click="generateText"
          >
            <u>Generate based on post text</u>
          </p>

          <div class="d-flex" style="gap: 10px" v-if="imageSrc.length > 0">
            <v-card
              hover
              style="cursor: pointer"
              width="100%"
              class="pa-2"
              v-for="(img, index) in imageSrc"
              :key="index"
              @click="useGeneratedImage(`data:image/png;base64,${img.base64}`)"
            >
              <v-img
                width="200"
                height="200"
                contain
                :src="`data:image/png;base64,${img.base64}`"
              ></v-img>
            </v-card>
          </div>
          <div
            v-if="imageSrc.length > 0"
            style="display: grid; grid-template-columns: 1fr 1fr 1fr; gap: 10px"
          >
            <v-btn
              block
              @click="useGeneratedImage(`data:image/png;base64,${imageSrc[0]}`)"
              >Use</v-btn
            >
            <v-btn
              block
              @click="
                status = 'prompt';
                imagePrompt = '';
              "
              >Edit</v-btn
            >
            <v-btn block @click="startOver">Start over</v-btn>
          </div>
        </div>
        <div v-if="tab === 3">
          <div class="d-flex justify-space-between align-center mb-6 px-4">
            <v-btn
              height="38"
              elevation="0"
              color="accent"
              class="primary--text"
              style="font-size: 10pt"
              >Add template</v-btn
            >

            <v-text-field
              class="px-4"
              variant="solo"
              flat
              label="Search templates"
              hide-details=""
              density="compact"
              bg-color="smoke"
              style="border-radius: 6px"
              prepend-inner-icon="mdi-magnify"
              v-model="search_templates"
            ></v-text-field>
          </div>
          <div
            v-if="loading.templates"
            style="width: 100%"
            class="d-flex justify-center mt-6"
          >
            <v-progress-circular
              indeterminate
              color="accent"
              width="2"
            ></v-progress-circular>
          </div>
          <v-data-table
            :headers="headers_templates"
            :items="templates"
            :search="search_templates"
            :items-per-page="5"
            hide-default-header
            @click:row="selectTemplate"
            style="cursor: pointer"
            :loading="loading.templates"
          >
            <template v-slot:[`item.url`]="{ item }">
              <div style="width: 100px" class="pa-1">
                <v-img :src="item.thumbnail" contain></v-img>
              </div>
            </template>

            <template v-slot:[`item.title`]="{ item }">
              <div class="py-2">
                <p class="mb-1">{{ item.name }}</p>
                <p
                  class="mb-0"
                  style="font-size: 10px; font-weight: 600; opacity: 0.4"
                >
                  <!-- {{ Number.parseFloat(item.size / 1024).toFixed(1) }}MB &#183; -->
                  <!-- {{ item.extension.toUpperCase() }} &#183; -->
                  {{ item.created_by_email.toUpperCase() }} &#183;
                  {{ formatDate(item.created_at) }}
                </p>
                <div class="d-flex flex-wrap mt-2" style="gap: 5px">
                  <v-chip
                    variant="flat"
                    size="small"
                    color="smoke"
                    v-for="i in item.tags"
                    :key="i"
                    >{{ i }}</v-chip
                  >
                </div>
              </div>
            </template>

            <template v-slot:[`item.actions`]="{ item }">
              <v-menu transition="slide-y-transition" bottom>
                <template v-slot:activator="{ props }">
                  <v-btn
                    v-bind="props"
                    icon="mdi-dots-vertical"
                    size="small"
                    variant="text"
                  >
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item
                    link
                    class="px-4"
                    @click="$store.dispatch('deleteMedia', item.uid)"
                  >
                    <v-icon size="small" class="mr-3">mdi-delete</v-icon>
                    <v-list-item-title>Delete</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </template>
          </v-data-table>
        </div>
      </v-card>
    </div>
  </v-navigation-drawer>
</template>

<script>
import { mapState } from "vuex";
import moment from "moment";
import { db } from "@/firebase";
import { collection, addDoc, updateDoc, doc } from "firebase/firestore";
import {
  getStorage,
  ref,
  uploadBytesResumable,
  getDownloadURL,
} from "firebase/storage";
import { httpsCallable } from "firebase/functions";
import { functions } from "@/firebase";
import { medium } from "@/mixins/medium";

export default {
  mixins: [medium],
  computed: {
    ...mapState({
      userProfile: (state) => state.users.userProfile,
      accounts: (state) => state.accounts.accounts,
      categories: (state) => state.posts.categories,
      media: (state) => state.media.media,
      media_loading: (state) => state.loading.media,
      loading: (state) => state.loading,
      templates: (state) => state.templates.templates,
      replace_thumbnail: (state) => state.post.replace_thumbnail,
      post_text: (state) => state.post.variations[0].text,
      brands: (state) => state.workspace.brands,
    }),
    prompts() {
      let list = [];
      console.log(this.brands);
      this.brands.map((b) => (list = list.concat(b.prompts)));
      return list;
    },
  },
  beforeDestroy() {
    this.$store.commit("clearMedium");
  },
  data() {
    return {
      generatingImages: false,
      imagePrompt: "",
      imageSrc: [],
      previous_response_id: null,
      prompt: "",
      headers: [
        { text: "Image", value: "url", align: "start" },
        {
          text: "Title",
          align: "start",
          sortable: false,
          value: "title",
        },

        { text: "Actions", value: "actions", align: "end" },
      ],
      headers_templates: [
        { text: "Image", value: "url", align: "start" },
        {
          text: "Title",
          align: "start",
          sortable: false,
          value: "title",
        },
        { text: "Actions", value: "actions", align: "end" },
      ],
      search_templates: "",
      status: "prompt",
    };
  },
  methods: {
    async useGeneratedImage(image) {
      const useGeneratedImage = httpsCallable(functions, "useGeneratedImage");
      const res = await useGeneratedImage(image);
      console.log(res.data);
      this.$store.dispatch("fetchMedia");
      this.tab = 0;
      this.selected.push(res.data);
    },
    async generateText() {
      this.generatingImages = true;
      console.log(this.post_text);
      const generateImagePrompt = httpsCallable(
        functions,
        "generateImagePrompt"
      );
      const prompt = await generateImagePrompt(this.post_text);
      this.imagePrompt = prompt.data;
      console.log(prompt.data);

      const generateImage = httpsCallable(functions, "openaiGenerateImage");
      const res = await generateImage({
        input: this.imagePrompt,
        prompt: this.prompt,
      });
      console.log(res);
      res.data.map((b) => this.imageSrc.push(b));
      this.generatingImages = false;
    },
    async generateImage() {
      this.generatingImages = true;
      const generateImage = httpsCallable(functions, "openaiGenerateImage");
      const res = await generateImage({
        input: this.imagePrompt,
        prompt: this.prompt,
        previous_response_id: this.previous_response_id,
      });
      this.status = "generating";

      res.data.map((b) => {
        this.imageSrc.push(b);
      });
      console.log(this.imageSrc);
      this.previous_response_id = res.data[0].previous_response_id;
      this.generatingImages = false;
    },
    startOver() {
      this.imageSrc = "";
      this.status = "prompt";
      this.previous_response_id = null;
    },
    enter(v) {
      if (v.code === "Enter") {
        this.searchMedia();
      }
    },
    change(v) {
      if (!v) {
        this.$store.commit("setMediumShow", false);
      }
    },
    onSelectionChange(newSelection) {
      if (newSelection.length <= 20) {
        this.selected = newSelection;
      } else {
        this.$store.commit("setNotification", {
          show: true,
          text: "Maxmium of 20 images allowed!",
          type: "primary",
          icon: "",
        });
      }
    },
    async searchMedia() {
      if (this.search) {
        this.search_loading = true;
        this.tab = 1;
        const get = httpsCallable(functions, "pexelsGet");
        const res = await get({ query: this.search });
        this.items = [];
        this.items = res.data.photos;
        this.next_page = res.data.next_page;
        this.nextPage();
        this.search_loading = false;
      }
    },
    async nextPage() {
      const get = httpsCallable(functions, "pexelsGetNext");
      const res = await get({ url: this.next_page });

      res.data.photos.forEach((p) => {
        this.items.push(p);
      });
      this.next_page = res.data.next_page;
    },
    formatDate(d) {
      return moment(d).format("DD-MM-YYYY");
    },
    async onFileChange() {
      var files = this.$refs.headerRef.files;
      const uploads = [...files];

      for (let x in uploads) {
        this.uploadFiles(uploads[x]);
      }
    },
    setPreviewSize(size) {
      this.$store.dispatch("setPreviewSize", size);
    },
    selectStockMedia(item) {
      console.log(item);
      this.selected.push(item);
      this.$store.dispatch("selectMedia", [item]);
    },
    selectMedia(click, row) {
      if (!this.selected.includes(row.item.uid)) {
        this.selected.push(row.item.uid);
      } else {
        let i = this.selected.findIndex((m) => m === row.item.uid);
        this.selected.splice(i, 1);
      }
      if (this.replace_thumbnail || this.type.includes("template")) {
        this.useSelectedMedia();
      }
    },
    useSelectedMedia() {
      let media = this.media.filter((m) => this.selected.includes(m.uid));
      this.$store.dispatch("selectMedia", media);
    },
    selectTemplate(click, row) {
      console.log(row.item);
      let x = row;
      x.item.type = "template";
      this.$store.dispatch("selectMedia", [x.item]);
    },
    resetValue(event) {
      event.target.value = "";
    },
    trigger() {
      this.$refs.headerRef.click();
    },
    async uploadFiles(upload) {
      this.search_loading = true;
      console.log(upload);
      var fileName = upload.name;
      var fileExtension = fileName.split(".").pop();
      const filesize = Math.floor(upload.size / 1024);

      function isType(fileExtension) {
        switch (fileExtension.toLowerCase()) {
          case "m4v":
            return "video";
          case "avi":
            return "video";
          case "mpg":
            return "video";
          case "mp4":
            return "video";
          case "jpg":
            return "image";
          case "gif":
            return "image";
          case "bmp":
            return "image";
          case "png":
            return "image";
          case "jpeg":
            return "image";
        }
        return null;
      }

      const storage = getStorage();

      const metadata = {
        contentType: upload.type,
      };
      const docRef = await addDoc(
        collection(db, "workspaces", this.userProfile.workspace, "media"),
        {
          title: fileName,
          extension: fileExtension,
          class: "media",
          created_at: Math.floor(Date.now() / 1000),
          created_by: this.userProfile.uid,
          created_by_email: this.userProfile.email,
          workspace: this.userProfile.workspace,
          size: filesize,
          posts: [],
          templates: [],
          tags: [],
          type: isType(fileExtension),
        }
      );
      const storageRef = ref(
        storage,
        `${this.userProfile.workspace}/media/${docRef.id}.${fileExtension}`
      );

      await uploadBytesResumable(storageRef, upload, metadata);

      const downloadURL = await getDownloadURL(storageRef);
      const updateRef = doc(
        db,
        "workspaces",
        this.userProfile.workspace,
        "media",
        docRef.id
      );

      await updateDoc(updateRef, {
        uid: docRef.id,
        src: downloadURL,
      });

      this.$store.commit("setNotification", {
        show: true,
        text: "Media added!",
        type: "primary",
        icon: "",
      });

      this.$store.dispatch("fetchMedia");
      this.search_loading = false;
    },
  },
};
</script>

<style lang="scss" scoped>
input {
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0;
  width: 0.1px;
  height: 0.1px;
}

.tab {
  background-color: white;
  border-radius: 6px 6px 0 0;
  text-transform: none;
  font-size: 12px;
  opacity: 0.6;
}
.active-tab {
  opacity: 1;
}

.stockphotos {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  max-height: 60vh;
  overflow: scroll;
  &.small {
    img {
      max-height: 100px;
    }
  }

  &.medium {
    img {
      max-height: 150px;
    }
  }

  &.large {
    img {
      max-width: 100%;
    }
  }

  img {
    border-radius: 6px;
  }

  img:hover {
    outline: 2px solid #cfb8ff;
  }
}
</style>
